<template>
  <img src="/img/payments/mastercard.png" width="29" height="18" alt="Mastercard">
</template>
